// material-ui
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function Footer() {
  const footerLinkProps = { target: '_blank', variant: 'caption', sx: { color: 'text.secondary' } };
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      sx={{ gap: 1.5, alignItems: 'center', justifyContent: 'space-between', p: '24px 16px 0px', mt: 'auto' }}
    >
      <Typography variant="caption" sx={{ color: 'text.secondary' }}>
        &copy; {new Date().getFullYear()}{' '}
        <Link href="https://privacypal.ai" target="_blank" underline="hover" sx={{ color: 'primary.main' }}>
          PrivacyPal
        </Link>{' '}
        · Partner Portal
      </Typography>
      <Stack direction="row" sx={{ gap: 1.5, alignItems: 'center', justifyContent: 'space-between' }}>
        <Link href="https://privacypal.ai" {...footerLinkProps}>
          privacypal.ai
        </Link>
        <Link href="https://privacypal.ai/contact.html" {...footerLinkProps}>
          Support
        </Link>
        <Link href="https://privacypal.ai/privacy.html" {...footerLinkProps}>
          Privacy
        </Link>
      </Stack>
    </Stack>
  );
}
